<template>
	<div>
		<div v-if="loadingCache" id="blockchain-data-loading">
            <div class="lds-facebook"><div></div><div></div><div></div></div>
            <div>{{ loadingText }}</div>
		</div>
		<div v-else style="float: left; width: 100%">
			<BlockchainDashboard :showNFT="true" :type="'Animal Health'" :subtype="'Aquaculture'" :incomingBlockchainCache="bcCache" ref="BlockchainDashboard" :year="year" />
		</div>
	</div>
</template>

<script>

import BlockchainDashboard from './BlockchainDashboard.vue';
export default {
	name: "CryopreservedContent",
	components: {
		BlockchainDashboard,
	},
	data: function () {
		return {
			bcCache: null,
			loadingCache: true,
			loadingText: null,
			loadingTextPhrases: [
				"Loading... please wait.",
				"Fetching data...",
				"Processing your request...",
				"Almost there...",
				"Hang tight, we're working on it...",
				"Just a moment...",
				"Loading content...",
				"Please be patient...",
				"Gathering information...",
				"This won't take long...",
				"Loading resources...",
				"Hold on, we're almost done...",
				"Please wait while we load...",
				"Loading data, please wait...",
				"Preparing your experience...",
				"Stay tuned...",
				"We're getting things ready...",
				"Just a bit more loading...",
				"Thank you for your patience...",
				"Loading, thank you for waiting...",
				"Connecting to the blockchain...",
				"Verifying transactions...",
				"Syncing with the network...",
				"Fetching blockchain data...",
				"Processing blockchain requests...",
				"Loading blockchain ledger...",
				"Validating blocks...",
				"Updating blockchain state...",
				"Connecting to blockchain nodes...",
				"Loading smart contracts...",
				"Interacting with the blockchain...",
				"Waiting for blockchain confirmation...",
				"Loading decentralized data...",
				"Fetching blockchain transactions...",
				"Retrieving blockchain records...",
				"Checking blockchain integrity...",
				"Updating blockchain ledger...",
				"Connecting to the decentralized network...",
				"Loading blockchain information...",
				"Ensuring blockchain security..."                    
			]
		};
	},
	props: {year: String}, // Settings object to pass to the child components
	created: async function() {
		// dynamic loading text
		this.loadingText = await this.updateLoadingText();
		console.log("Getting blockchain content")
        this.bcCache = await this.retrieveBlockchainFromAPI();
		this.loadingCache = false;
		console.log("Year from parent: ", this.year);
    },
	mounted: async function () {
		console.log("Mounted Cryopreserved page")

		// Set the loading text to be visible after 1 second
		setTimeout(() => {
			this.loadingTextIsVisible = true;
		}, 1000);

		// dynamic loading text
		this.timer = await setInterval(() => {
			this.loadingText = this.getRandomLoadingText(this.loadingTextPhrases);
		}, 3000) // 3 sec     
	},
	methods: {
	updateLoadingText(){
			// Function that picks a random line and returns a promise
			const loadingTextPromise = new Promise((resolve) =>{
				resolve(this.getRandomLoadingText(this.loadingTextPhrases));
			})

			loadingTextPromise.then((text) => { this.loadingText = text; });
		},
		getRandomLoadingText(arr) {
			// Ensure the array is not empty
			if (arr.length === 0) {
				throw new Error('Array is empty');
			}

			// Get a random index from the array
			const randomIndex = Math.floor(Math.random() * arr.length);

			// Return the element at the random index
			return arr[randomIndex];
		},
		async retrieveBlockchainFromAPI() {
            let items = [];
            let lastEvaluatedKey;
			const blockChainTableName = `${process.env.VUE_APP_BLOCKCHAIN_AQUACULTURE_DB_TABLE_NAME}_${this.year}`;
            
            const headers = {
                'Content-Type': 'application/json;charset=utf-8',
                'authorization': localStorage.idtoken
            };

            console.log("Getting ALL items from API...")
            do {
                let params;
                
                // console.log("Looping... LAst evaluated key: ", lastEvaluatedKey)
                if (!lastEvaluatedKey) params = new URLSearchParams({ TableName: blockChainTableName });
                else params = new URLSearchParams({
                    TableName: blockChainTableName,
                    ExclusiveStartKey: JSON.stringify(lastEvaluatedKey)
                });
                
                let url = process.env.VUE_APP_BLOCKCHAIN_API_URI + `?${params}`; // Build the URL with query params

                try {
                    // console.log("Makingr request... URL: ", url, " Headers: ", headers, " Params: ", params);
                    let response = await this.$http.get(url, { headers });
                    
                    // console.log("Items retrieved: ", response.length)
                    items = items.concat(response.data.Items);
                    lastEvaluatedKey = response.data.LastEvaluatedKey;
                }
                catch (error) {
                    console.error('Error fetching items:', error);
                    break; // Exit the loop if there's a critical error
                }
            } while (lastEvaluatedKey);

            // Use the 'items' array for further processing or display in your Vue component
            //console.log('All items retrieved:', items);
            //console.log('All items retrieved (stringified):', JSON.stringify(items));
            console.log('All items retrieved...', );
             

            return items;           
        },
	}
};
</script>

<style></style>